/* Cloud de Vie — global interactions */
(function () {
  'use strict';

  // Mobile menu toggle
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-mobile-toggle]');
    if (toggle) {
      var menu = document.getElementById('MobileMenu');
      if (menu) menu.classList.toggle('is-open');
    }
  });

  // Quantity selectors
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty]');
    if (!btn) return;
    var input = btn.parentElement.querySelector('input[name="quantity"]');
    if (!input) return;
    var val = parseInt(input.value, 10) || 1;
    if (btn.getAttribute('data-qty') === 'plus') val += 1;
    else val = Math.max(1, val - 1);
    input.value = val;
  });

  // Contact form UX enhancement (non-blocking; Shopify handles submit)
  var contactForm = document.getElementById('ContactForm');
  if (contactForm) {
    contactForm.addEventListener('submit', function () {
      var submitBtn = contactForm.querySelector('[type="submit"]');
      if (submitBtn) {
        submitBtn.setAttribute('disabled', 'disabled');
        submitBtn.textContent = 'Sending…';
      }
    });
  }
})();
